/* Corewella Funnel — v3 behavior
   Scoped to .cf-page. Adds:
     - Subscribe toggle per bundle card (swaps hidden selling_plan + visible price live)
     - Sticky mobile + desktop CTA show/hide
     - Smooth in-page anchor scroll with header clearance
     - Add-to-cart guard + DIRECT-TO-CHECKOUT (skips cart drawer)
     - Scroll-triggered fade-ins (IntersectionObserver)
   FAQ accordion uses native <details>/<summary> — no JS needed.
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var page = document.querySelector('.cf-page');
    if (!page) return;

    // Mark the body so the global site header + footer can be hidden via CSS
    // on this template only. Removed on unload so SPA-style navigation still
    // shows the chrome on other pages.
    document.body.classList.add('cf-funnel-active');

    /* ----- Subscribe toggle per bundle card -----
       Swaps:
         - the hidden `selling_plan` input value (enables / disables subscription)
         - the visible price (one-time ↔ subscription price)
         - the secondary "or $X with Subscribe & Save" sub-line label
       Uses data attributes seeded by Liquid (data-onetime / data-sub).
    */
    page.querySelectorAll('.cf-bundle__form').forEach(function (form) {
      var toggle = form.querySelector('[data-cf-bundle-sub]');
      var planInput = form.querySelector('[data-cf-plan-input]');
      var card = form.closest('.cf-bundle');
      if (!toggle || !card) return;
      var priceEl = card.querySelector('[data-cf-price-now]');
      var subLineEl = card.querySelector('[data-cf-sub-line]');
      var onetime = priceEl ? priceEl.getAttribute('data-onetime') : null;
      var subPrice = priceEl ? priceEl.getAttribute('data-sub') : null;
      var planOriginal = planInput ? planInput.value : '';

      function sync() {
        var subOn = !!toggle.checked;

        // Toggle hidden selling_plan input
        if (planInput) {
          if (subOn) {
            planInput.value = planOriginal;
            planInput.disabled = false;
          } else {
            planInput.value = '';
            planInput.disabled = true;
          }
        }

        // Update visible price
        if (priceEl && onetime && subPrice) {
          priceEl.textContent = subOn ? subPrice : onetime;
        }

        // Swap secondary line so the alternate option is always shown below
        if (subLineEl) {
          var altLabelSubOn = subLineEl.getAttribute('data-sub-on-label');
          var altLabelSubOff = subLineEl.getAttribute('data-sub-off-label');
          if (subOn && altLabelSubOn) {
            subLineEl.textContent = altLabelSubOn;
          } else if (!subOn && altLabelSubOff) {
            subLineEl.textContent = altLabelSubOff;
          }
        }

        // Visual state on toggle pill
        card.classList.toggle('is-sub-active', subOn);
      }
      toggle.addEventListener('change', sync);
      sync();
    });

    /* ----- Sticky mobile + desktop CTAs ----- */
    var stickyMobile = page.querySelector('.cf-stickycta');
    var deskCta = page.querySelector('.cf-deskcta');
    var hero = page.querySelector('.cf-hero');
    var bundles = page.querySelector('#cf-bundles');

    function showCtas(show) {
      if (stickyMobile) stickyMobile.classList.toggle('is-visible', show);
      if (deskCta) deskCta.classList.toggle('is-visible', show);
    }

    if (hero) {
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          showCtas(!entry.isIntersecting);
        });
      }, { threshold: 0.05 });
      heroObserver.observe(hero);
    }
    if (bundles) {
      var bundlesObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) showCtas(false);
        });
      }, { threshold: 0.1 });
      bundlesObserver.observe(bundles);
    }

    /* ----- Smooth in-page anchor scroll ----- */
    page.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = a.getAttribute('href');
        if (!target || target === '#') return;
        var el = page.querySelector(target);
        if (!el) return;
        e.preventDefault();
        var rect = el.getBoundingClientRect();
        var top = window.pageYOffset + rect.top - 100;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* ----- Add-to-cart → direct to checkout (skip cart drawer) -----
       Intercepts bundle form submits, POSTs to /cart/add.js, then
       navigates straight to /checkout. Falls back to native submit
       if fetch fails. */
    page.querySelectorAll('[data-cf-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) { e.preventDefault(); return; }

        // Honor browsers without fetch — fall through to native submit
        if (!window.fetch) {
          if (btn) lockBtn(btn);
          return;
        }

        e.preventDefault();
        if (btn) lockBtn(btn);

        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            // Restore and try native submit as fallback
            if (btn) unlockBtn(btn);
            form.submit();
          });
      });
    });

    function lockBtn(btn) {
      btn.dataset.originalLabel = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
    }
    function unlockBtn(btn) {
      if (btn.dataset.originalLabel) {
        btn.textContent = btn.dataset.originalLabel;
        btn.disabled = false;
      }
    }

    /* ----- Scroll-triggered fade-ins ----- */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fadeEls = page.querySelectorAll('.cf-fade');
    if (reduceMotion) {
      fadeEls.forEach(function (el) { el.classList.add('is-in'); });
    } else if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      fadeEls.forEach(function (el) { fadeObserver.observe(el); });
    } else {
      fadeEls.forEach(function (el) { el.classList.add('is-in'); });
    }
  });
})();
